export const initialState = {
  answers: {},
  isLoading: false,
  isSaving: false,
  queue: [],
  azubiToShow: {},
  chapterStatuses: {},
}

export default function ausbildungsplan(state = initialState) {
  return state
}
